import { QueryClient, UseQueryOptions, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { axiosClient } from "$/http"

import { minutes, seconds } from "@/3514/utils/time.utils"
import Urls from "@/api/urls"

import { QueryKey } from "../constants"

const getAvConfirmRules = async () => {
    const { data } = await axiosClient.get(Urls.confrimAvRules())
    return data
}

export function useAvailabilityConfirmRules(options?: Partial<UseQueryOptions>) {
    return useQuery<any, AxiosError, any>({
        queryKey: [QueryKey.AvConfirmRules],
        queryFn: getAvConfirmRules,
        retry: 1,
        retryDelay: seconds(5),
        throwOnError: false,
        ...options,
        refetchOnMount: options?.refetchOnMount || "always"
    })
}

export async function coachAvailabilityConfirmQueryPrefetcher({ qc }: { qc: QueryClient }): Promise<void> {
    await qc.prefetchQuery({
        queryKey: [QueryKey.AvConfirmRules],
        queryFn: getAvConfirmRules,
        staleTime: minutes(20),
        gcTime: minutes(20),
        retry: false
    })
}
